import styled from 'styled-components';
import { pxToRem } from 'utils/convert';

export const PaginationContainer = styled.div`
  display: inline-flex;
`;

export const Page = styled.button<{ $isOverflow: boolean }>`
  background: none;
  border-radius: ${pxToRem(3)};
  color: #2e8ece;
  line-height: ${pxToRem(14)};
  padding: ${pxToRem(5)} ${pxToRem(10)};
  pointer-events: ${({ $isOverflow }) => ($isOverflow ? 'none' : 'inherit')};
  &:hover {
    background: #rgba(0, 0, 0, 0.1);
  }
  &[data-selected='true'] {
    color: #fff;
    font-weight: 600;
    pointer-events: none;
  }
  &[data-role='overflow-page'] {
    padding: 0;
    margin-right: ${pxToRem(4)};
    border: none;
    background: transparent;
  }
`;
